import React, { createContext, Context as ReactContext } from "react"
import { getNestedObject } from "../utils/helpers"
import { SchemaElement, Schema } from "./StateSchema"

const useContext = <T>(contextHandle: ReactContext<T | undefined>): T => {
  const context = React.useContext(contextHandle)
  if (context === undefined) {
    throw new Error("Context must be used within a ContextProvider")
  }
  return context
}

class Context {
  stateContext: ReactContext<any>
  dispatchContext: ReactContext<any>
  schema: Schema

  constructor(schema: Schema) {
    // Deler opp context, ref: https://kentcdodds.com/blog/how-to-use-react-context-effectively
    this.stateContext = createContext<any>(undefined)
    this.dispatchContext = createContext<any>(undefined)
    this.schema = schema

    this.useDispatch = this.useDispatch.bind(this)
    this.useState = this.useState.bind(this)
    this.reducer = this.reducer.bind(this)
  }

  useDispatch(schemaElement: SchemaElement): (value: any) => void {
    // eslint-disable-next-line
    const dispatch = useContext(this.dispatchContext)

    return (value: any) => {
      const update = schemaElement._updateCreator(value)
      dispatch(update)
    }
  }

  useState(schemaElement: SchemaElement): any {
    if (schemaElement === undefined) {
      throw new Error(
        "Cannot call 'Context.useState' without scheme element argument"
      )
    }
    // eslint-disable-next-line
    const fullState = useContext(this.stateContext)
    return getNestedObject(fullState, schemaElement._key)
  }

  reducer(state: any, action: { key: string; value: any }): any {
    console.log(action)
    const schemaElement = getNestedObject(this.schema, action.key)
    if (!schemaElement) {
      throw new Error(`No schema element for action ${action.key}`)
    }
    const newState = schemaElement._reducer(state, action)
    console.log(newState)
    return newState
  }
}

export default Context
